<div class="main">
  <img class="loading-spinner w-48 h-48" src="/assets/images/LoaderGIF.gif">
</div>
